var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 902,
    viewBox: "0 0 1400 902",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-547 695.258C-547 695.258 276.873 379.219 276.873 221.199C276.873 63.1798 -46.6688 -118.887 -146.22 144.766C-245.771 408.418 -30.0292 664.719 229.672 814.632C659.9 1062.98 1370.22 422.159 1354.77 221.199C1339.33 20.2397 1096.46 -87.9698 949.703 105.26C802.95 298.49 1041.36 615.883 1296.42 695.258C1532.18 768.63 1886 466.817 1886 466.817",
    stroke: "white",
    strokeWidth: 62
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector11);
export default __webpack_public_path__ + "static/media/Vector11.db44142c9fd2a95454383f37689744fd.svg";
export { ForwardRef as ReactComponent };